// ─── Notifications Vuex Module ─────────────────────────────────────────────
// Socket.IO event'lerinden gelen warning/info bildirimlerini tutar.
// State: ring buffer (son 50). Component'ler unreadCount'tan bell icon badge çeker.

const MAX_NOTIFICATIONS = 50

export default {
  namespaced: true,
  state: {
    items: [], // [{ id, type, reason, message, source, timestamp, read }]
    unreadCount: 0,
  },
  getters: {
    items: s => s.items,
    unreadCount: s => s.unreadCount,
    latest: s => s.items.slice(0, 10),
  },
  mutations: {
    ADD(state, n) {
      state.items.unshift(n)
      if (state.items.length > MAX_NOTIFICATIONS) state.items.length = MAX_NOTIFICATIONS
      if (!n.read) state.unreadCount += 1
    },
    MARK_ALL_READ(state) {
      state.items.forEach(n => { n.read = true })
      state.unreadCount = 0
    },
    CLEAR(state) {
      state.items = []
      state.unreadCount = 0
    },
  },
  actions: {
    add({ commit }, payload) {
      const n = {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        type: payload.type || 'info', // info / warning / danger / success
        reason: payload.reason || null,
        message: payload.message || '',
        source: payload.source || null, // { kind: 'bot'|'target', id }
        data: payload.data || null,
        timestamp: payload.timestamp || Date.now(),
        read: false,
      }
      commit('ADD', n)
    },
    markAllRead({ commit }) { commit('MARK_ALL_READ') },
    clear({ commit }) { commit('CLEAR') },
  },
}
